import { login, refresh, LoginDetails } from "../auth/login";
import StorageController from "./storageController";

export default class AuthenticationController {

    public static readonly LogoutEvent = "logout";
    public static readonly LoginEvent = "login";

    private loginSection: HTMLElement;
    private loginButton: HTMLButtonElement;
    private loginEnvironment: HTMLInputElement;
   
   
    private logoutSection: HTMLElement;
    private logoutButton: HTMLButtonElement;
    private environmentLabel: HTMLElement;
    private userName: HTMLElement;

    private currentDetails: LoginDetails|null = null;

    public constructor(container: HTMLElement, private eventHost: HTMLElement) {
        this.loginSection = container.querySelector(".js-login") as HTMLElement;
        this.loginEnvironment = this.loginSection.querySelector(".js-login-environment") as HTMLInputElement;
        this.loginEnvironment.value = 
            StorageController.get(environmentKey) ??        // Prio 1: specifically used for this file
            StorageController.getGlobal(environmentKey) ??  // Prio 2: global last used
            "";                                             // Prio 3: empty

        this.loginButton = this.loginSection.querySelector(".js-login-btn") as HTMLButtonElement;
        this.loginButton.onclick = () => this.startLogin();

        this.logoutSection = container.querySelector(".js-logout") as HTMLElement;
        this.environmentLabel = this.logoutSection.querySelector(".js-env") as HTMLElement;
        this.userName = this.logoutSection.querySelector(".js-name") as HTMLElement;
        this.logoutButton = this.logoutSection.querySelector(".js-logout-btn") as HTMLButtonElement;
        this.logoutButton.onclick = () => this.startLogout();

        this.updateUI();
        container.hidden = false;
    }

    private updateUI() {
        if (this.currentDetails) {
            this.loginEnvironment.value = this.currentDetails?.environment
            this.loginSection.hidden = true;
            this.logoutSection.hidden = false;
            const a = document.createElement("a");
            a.href = this.currentDetails.environment;
            a.target = "_blank";
            a.innerText = this.currentDetails.environment;
            if (this.environmentLabel) {
                this.environmentLabel.innerHTML = "";
                this.environmentLabel.appendChild(a);
            }

            this.userName.innerText = `${this.currentDetails.name}` 
        } else {
            this.loginSection.hidden = false;
            this.logoutSection.hidden = true;
        }
    }

    private async startLogout() {
        this.currentDetails = null;
        this.updateUI();
        this.eventHost.dispatchEvent(new CustomEvent(AuthenticationController.LogoutEvent))
    }


    private async startLogin() {
        try {
            this.loginEnvironment.disabled = true;
            this.loginButton.disabled = true;
            let environment = this.loginEnvironment.value;
            if (!(environment.startsWith("https://") || environment.startsWith("http://"))) {
                environment = "https://" + environment
            }
            let uri = new URL(environment);
            environment = `${uri.protocol}//${uri.hostname}`
            if (uri.port) {
                environment += `:${uri.port}`
            }
            environment += "/"
            const details = await login(environment);
            if (details != null) {
                StorageController.set(environmentKey, environment)
                StorageController.setGlobal(environmentKey, environment);
                this.currentDetails = details;
                this.eventHost.dispatchEvent(new CustomEvent(AuthenticationController.LoginEvent))
            } else {
                this.currentDetails = null;
                this.eventHost.dispatchEvent(new CustomEvent(AuthenticationController.LogoutEvent))
            }
        } catch (e) {
            console.error(e);
        } finally {
            this.loginEnvironment.disabled = false;
            this.loginButton.disabled = false;
        }

        this.updateUI();
    }

    get url() {
        return this.currentDetails?.environment ?? "";
    }     
    
    get bearer() {
        return this.currentDetails?.accessToken ?? "";
    } 

    get authenticated() {
        return !!this.currentDetails;
    } 

    async refresh(): Promise<boolean> {
        if (this.currentDetails?.refreshToken) {
            const details = await refresh(this.currentDetails.environment, this.currentDetails.refreshToken);
            if (details == null) {
                this.currentDetails = null;
                this.eventHost.dispatchEvent(new CustomEvent(AuthenticationController.LogoutEvent));
                return false;
            }
            this.currentDetails.accessToken = details.accessToken;
            this.currentDetails.refreshToken = details.refreshToken;
            return true;
        }
        this.currentDetails = null;
        this.eventHost.dispatchEvent(new CustomEvent(AuthenticationController.LogoutEvent));
        return false;
    }

}

const environmentKey = "environment"; 